import React, { Component, createRef } from "react";
import { withRouter } from "react-router";

import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import moment from "moment";

import debounce from "lodash.debounce";

import cn from "classnames";

import axios from "../../axios-instance.js";

import Container from "../../components/UI/Container/Container.js";
import Icon from "../../components/UI/Icon/Icon.js";
import { Stepper } from "../../components/Stepper/Stepper.js";
import NewLoader from "../../components/NewLoader/NewLoader.js";

import { FillFields, ChoosePaymentMethod, SelectTickets } from "./Steps/index.js";
import TermsAndConditionsModal from "../SeasonPass/TermsAndConditionsModal/TermsAndConditionsModal.js";
import { fee, paymentMethodOptions } from "../SeasonPass/constants.js";
import { getCurrencieLabel } from "../../constants/currencies.js";
import { filterUnavailableTicketTemplates } from "../../helpers/filterUnavailableTicketTemplates.js";
import { showErrorModal, showInfoModal } from "../../modals/index.js";

import PleaseWait from "../../images/please-wait-season-pass-modal.svg";
import Warning from "../../images/warning.svg";

import "../SeasonPass/SeasonPass.sass";
import "./OpenSell.sass";
import { isValidEmail } from "../../helpers/validators.js";
import { getRegion } from "../../helpers/getRegion";
import { OfferSeatsToTicket, ticketTypes } from "../../helpers/ticketHelper.ts";
import { applyDiscounts, getPrice, getTotalFee } from "../../helpers/ticketPriceHelper.ts";
import { executePayment } from "../../helpers/paymentHelper/paymentHelper.ts";
import { paymentTypes } from "../../constants/paymentType.ts";
import { getCustomURLs } from "../../helpers/getCustomURLs.js";
import { showErrorPaymentModal, showProcessingPaymentModal, showRefundPaymentModal, showSuccessPaymentModal } from "../../components/Sells/Modals/statusModals.js";
import { getCurrentLanguageTexts, setLangCode } from "../../constants/seasonPassPersonalInfoLangs.js";
import { OfferSteps } from "./Steps/OfferSteps.js";
import { getVisibleBankLogos } from "../../helpers/getVisibleBankLogos.js";

const MySwal = withReactContent(swal);

class OpenSell extends Component {
  state = {
    fields: {
      fullName: "",
      physicalAddress: "",
      city: "",
      postalCode: "",
      phoneNumber: "",
      buyerEmail: "",
      birthday: null,
      gender: "",
      paymentMethod: null,
      companyName: "",
      companyVatNumber: "",
      buyerCountry: "",
    },
    checkboxeFields: {
      termsAndConditionsChecked: false,
    },
    tickets: [],
    transactionData: {
      orderId: "",
      paymentAmount: 0,
      currencyCode: "RSD",
    },
    eventData: null,
    isOffers: false,
    step: 1,
    themeColor: "#F95700",
    hasSeats: undefined,
    feeRate: fee,
    fixedFeeRate: 0,
    loading: true,
    submittBlocked: false,
    reapetedBuyerEmail: "",
    coupon: null,
    theme: {
      fontFamily: '',
      primaryColor: '',
      primarySemiLightColor: '',
      primaryLightColor: '',
      secondaryColor: '',
      secondaryLightColor: '',
      backgroundColor: '',
      primaryTextColor: '',
      secondaryTextColor: '',
    },
    isBtnHover: false,
    isPageLoaded: false,
    chart: null,
    isNextStepLoading: false,
  };

  formRef = createRef();

  handleChangeStep = async (nextStep) => {
    const tickets = [...this.state.tickets];
    const chart = this.state.chart;

    this.setState({ isNextStepLoading: true });

    try {
      if (this.state.step === 1 && chart) {
        await chart.clearSelection();
        tickets.forEach(t => {
          this.onTicketAdded(t)
        })
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ step: nextStep, isNextStepLoading: false });
      this.handleMouseLeave();
    }
  };

  setOrderDataToState = (data) => {
    const fields = {
      ...this.state.fields,
      fullName: data.fullName,
      physicalAddress: data.physicalAddress,
      city: data.city,
      postalCode: data.postalCode,
      phoneNumber: data.phoneNumber,
      buyerEmail: data.buyerEmail,
      birthday: data.birthday && moment(data.birthday).year() >= 1935 ? data.birthday : null,
      gender: data.gender,
      companyName: data.companyName,
      companyVatNumber: data.companyVatNumber,
      buyerCountry: data.buyerCountry,
    };

    this.setState({
      fields,
    });
  };

  showSalesUnavailableModal = (text) => {
    MySwal.fire({
      title: text,
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  showPleaseWaitModal = () => {
    const txt = getCurrentLanguageTexts();

    MySwal.fire({
      imageUrl: PleaseWait,
      title: txt.sellPageModals["Please wait"],
      text: txt.sellPageModals["You will be redirected to the payment page"],
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  getTransactionData = async () => {
    const txt = getCurrentLanguageTexts();

    try {
      const id = !!this.props.match.params.id
        ? this.props.match.params.id
        : this.props.match.params.transactionId;

      const { data: transaction } = await axios.get(
        `Transaction/${id}`
      );
      if (transaction) {
        this.handleOrderStatuses(transaction);
        this.setOrderDataToState(transaction);
      }
    } catch (e) {
      showErrorModal({
        text: txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme",
      });
      console.log(e);
    }
  };

  setPrice = () => {
    const { tickets, eventData, coupon, isOffers } = this.state;

    if (!isOffers) {
      applyDiscounts(tickets, eventData.ticketTemplates);
    }

    this.setTransactionData({
      paymentAmount: getPrice(tickets, eventData.ticketTemplates, coupon),
    });
  };

  paymentStatus = -1;
  handleOrderStatuses = (transaction) => {
    const { isOffers, eventData } = this.state;

    if (!this.state.isPageLoaded) {
      return;
    }

    if (transaction.paymentStatus === 5 ||
      (transaction.paymentStatus === 0
        && !window.location.href.includes("offers"))) {
      setTimeout(() => {
        this.getTransactionData();
      }, 4000);
    }

    if (this.paymentStatus !== transaction.paymentStatus) {
      const { sellPageTxt } = getCurrentLanguageTexts();

      if (transaction.refundSource === 2) {
        const tickets = transaction.seats.map(({ area, side, row, seat }) => (
          `${area}-${side}-${row}-${seat}`
        )).join(', ');

        showInfoModal({
          imageAltText: "Attention",
          title: "Attention",
          customClass: "seasonpass__modal_info seasonpass__modal partizan-info-modal partizan-info-modal--red-message modal-with-custom-theme",
          text: `${sellPageTxt.tickets}: "${tickets}" ${sellPageTxt["have been refunded"]}.`,
          image: Warning
        });
      } else {
        switch (transaction.paymentStatus) {
          // Processing
          // case 0:
          //   if (window.location.href.includes("offers")) {
          //     break;
          //   }
          case 5:
            showProcessingPaymentModal({ ...transaction });
            break;
          // Success
          case 1:
            showSuccessPaymentModal({
              ...transaction,
              buyMoreUrl: (!!eventData && !!eventData.slug) ? `/events/${eventData.slug}` : null,
              showConfirmButton: !isOffers
            });

            if (isOffers) {
              this.setState({ submittBlocked: true });
            }
            break;
          // Failed
          case 2:
            showErrorPaymentModal({ ...transaction });
            break;
          // Refunded
          case 4:
            showRefundPaymentModal({ ...transaction });
            break;
          default:
            break;
        }
      }
    }

    this.paymentStatus = transaction.paymentStatus;
  };

  createPathnameWithOrderId = (id) => {
    const pathname = String(this.props.location.pathname);
    const splitedPathname = pathname.split("/");
    const isIncludeId = splitedPathname.length >= 4;
    if (isIncludeId) {
      return `/${splitedPathname[1]}/${splitedPathname[2]}/${id}`;
    }
    return pathname + "/" + id;
  };

  createRedirectURL = (id) => {
    const { isOffers } = this.state;

    if (isOffers) {
      return window.location.href + "?";
    }

    const origin = window.location.origin;
    const pathname = this.createPathnameWithOrderId(id);

    return `${origin}${pathname}?`;
  };

  setTransactionData = (data) => {
    const paymentAmount = data.paymentAmount;

    const orderId = data.orderId || this.state.transactionData.orderId || "";

    const { API_URL } = getCustomURLs();

    const transactionData = {
      ...this.state.transactionData,
      ...data,
      orderId,
      redirectURL: this.createRedirectURL(orderId),
      resURL: `${API_URL}/Payment/Webhook/Kopa`,
    };

    if (paymentAmount) {
      const total = paymentAmount + paymentAmount * this.state.feeRate + this.state.fixedFeeRate * this.state.tickets.length;

      transactionData.paymentAmount = total;
    }

    this.setState({
      transactionData,
    });
  };

  handleSubmit = async () => {
    const txt = getCurrentLanguageTexts();
    try {
      this.showPleaseWaitModal();

      const {
        fields: { paymentMethod, ...otherFields },
        eventData,
        tickets,
        coupon,
      } = this.state;

      await executePayment({
        eventData: eventData,
        paymentMethod: paymentMethod.id,
        paymentType: paymentTypes.online,
        couponCode: coupon ? coupon.barcode : '',
        redirectUrl: this.createRedirectURL('{Id}'),
        tickets: tickets,
        transaction: {
          ...otherFields,
          id: this.props.match.params.transactionId || '',
        }
      });

    } catch (e) {
      console.log(e);
      showErrorModal({
        text: txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme",
      });
    }
  };

  handleChange = (name, value) => {
    if (name) {
      this.setState({ fields: { ...this.state.fields, [name]: value } });
    }
  };

  handleRepaetEmailChange = debounce((value) => {
    this.setState({ reapetedBuyerEmail: value.trim() });
  }, 700);

  showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    MySwal.fire({
      html: <TermsAndConditionsModal />,
      width: "64em",
      showCloseButton: true,
      customClass: "partizan-info-modal modal-with-custom-theme",
    });
  };

  handleChangeCheckbox = (name) => {
    if (name) {
      this.setState({
        checkboxeFields: {
          ...this.state.checkboxeFields,
          [name]: !this.state.checkboxeFields[name],
        },
      });
    }
  };

  checkActionButtonDisabled = () => {
    const {
      step,
      fields: {
        companyName,
        companyVatNumber,
        paymentMethod,
        birthday,
        phoneNumber,
        ...otherFields
      },
      checkboxeFields,
      submittBlocked,
      tickets,
      loading,
      isOffers,
      reapetedBuyerEmail,
    } = this.state;

    if (otherFields.buyerEmail && !isValidEmail(otherFields.buyerEmail))
      return true;

    if (submittBlocked || loading) return true;

    if (isOffers) {
      return (
        !checkboxeFields.termsAndConditionsChecked
        || !Object.keys(otherFields).every((key) => !!otherFields[key])
        || !moment(birthday).isValid()
        || !phoneNumber
        || phoneNumber.length < 5
        || (!!companyName && !companyName.trim() && !!companyVatNumber && !!companyVatNumber.trim())
        || (!!companyName && !!companyName.trim() && !!companyVatNumber && !companyVatNumber.trim())
      );
    };

    switch (step) {
      case 1:
        return !tickets.length;
      case 3:
        return !paymentMethod || reapetedBuyerEmail !== otherFields.buyerEmail;
      case 2:
        return (
          !Object.keys(otherFields).every((key) => !!otherFields[key])
          || !moment(birthday).isValid()
          || !phoneNumber
          || phoneNumber.length < 5
          || !checkboxeFields.termsAndConditionsChecked
          || (!companyName.trim() && !!companyVatNumber.trim())
          || (!!companyName.trim() && !companyVatNumber.trim())
        );
      default:
        return false;
    }
  };

  onTicketAdded = (ticket) => {
    if (ticket.type === ticketTypes.NO_SEAT) {
      const tickets = [...this.state.tickets, ticket];

      this.setState({ tickets }, () => this.setPrice());
    }


    if (this.state.chart && !ticket.masterTicket &&
      (this.state.tickets.some(t => t.label === ticket.label)
      ) && ticket.type === ticketTypes.MAP) {
      return;
    }

    const tickets = [...this.state.tickets, ticket];

    this.setState({ tickets }, () => this.setPrice());
  };

  onTicketRemoved = (ticket, manual = false) => {
    if (this.state.chart && ticket.type === ticketTypes.MAP) {
      this.state.chart.deselectObjects([ticket.label]);
    }

    if (this.state.chart && ticket.type === ticketTypes.MAP_NO_SEAT && manual) {
      this.state.chart.deselectObjects([{ label: ticket.label, amount: 1 }]);
      return;
    }

    if (ticket.type === ticketTypes.NO_SEAT) {
      const index = this.state.tickets.findIndex(i => i.ticketTemplateId === ticket.ticketTemplateId);

      this.setState(
        {
          tickets: this.state.tickets.filter((item, i) => i !== index),
        },
        () => this.setPrice()
      );
    }
    else if (ticket.type === ticketTypes.MAP_NO_SEAT) {
      const index = this.state.tickets.findIndex(i => i.label === ticket.label);
      this.setState(
        {
          tickets: this.state.tickets.filter((item, i) => i !== index),
        },
        () => this.setPrice()
      );
    }
    else if (ticket.type === ticketTypes.MAP) {
      this.setState(
        {
          tickets: this.state.tickets.filter((item) => item.id !== ticket.id),
        },
        () => this.setPrice()
      );
    }
  };

  setEventData = (data = {}, shouldfilterUnavailable = true) => {
    const txt = getCurrentLanguageTexts();

    document.documentElement.style.setProperty(
      "--partizan-theme",
      this.state.themeColor
    );

    if (!data.isSalesAvailable) {
      this.setState({ submittBlocked: true });
      this.showSalesUnavailableModal(
        data.salesNotAvailableText || txt.sellPageModals["Sales not available"]
      );
    }

    const isTickets = data.ticketTemplates.some(t => (
      t.allowedToSell > 0 ||
      (t.hasSeats && t.isAvailableToSale)
    ));

    if (!isTickets && data.isSalesAvailable) {
      this.setState({ submittBlocked: true });
      this.showSalesUnavailableModal(
        data.ticketsSoldText || txt.sellPageModals["Tickets sold out"]
      );
    }

    if (shouldfilterUnavailable) {
      data.ticketTemplates = filterUnavailableTicketTemplates(
        data.ticketTemplates
      );
    }

    this.setState({
      transactionData: {
        ...this.state.transactionData,
        accessToken: data.paymentToken,
        currencyCode: getCurrencieLabel(data.currencyId),
      },
      hasSeats: data.ticketTemplates.length
        ? data.ticketTemplates.filter(t => t.hasSeats) >= data.ticketTemplates.filter(t => !t.hasSeats)
        : undefined,
      feeRate: data.feeRate || fee,
      fixedFeeRate: data.fixedFeeRate || 0,
      eventData: data,
      fields: {
        ...this.state.fields,
        paymentMethod: {
          id: data.allowedPaymentProviders[0].providerId,
          value: paymentMethodOptions[data.allowedPaymentProviders[0].providerId],
          label: data.allowedPaymentProviders[0].methods[0].name,
        }
      },
      theme: data.pageUiTheme
    });
  };

  getEventData = async (transactionId) => {
    if (transactionId) {
      const { data } = await axios.get(
        `/EventPublicInfo/ByTransactionId/${transactionId}`
      );

      if (data.code === 4003) {
        throw data
      }

      this.setEventData({ ...data.result }, false);
      return;
    }

    const eventSlug = this.props.match.params.slug;
    const { data } = await axios.get(`/EventPublicInfo/BySlug/${eventSlug}`);

    this.setEventData({
      ...data,
    });
  };

  getOfferTransactionData = async () => {
    if (!this.props.match.params.transactionId) {
      return;
    }

    const transactionId = this.props.match.params.transactionId;

    let tickets = [];

    await this.getEventData(transactionId);

    const { data } = await axios.get(
      `Transaction/TransactionCreationModel/${transactionId}`
    );

    const serializedTransactionModel = JSON.parse(
      data.serializedTransactionCreationModel
    );

    const transactionModel = {};

    for (const key in serializedTransactionModel) {
      if (serializedTransactionModel.hasOwnProperty(key)) {
        transactionModel[key] = serializedTransactionModel[key];
      }
    }

    this.handleOrderStatuses(transactionModel);
    this.setOrderDataToState(transactionModel);

    tickets = serializedTransactionModel.seats.map((seat) => OfferSeatsToTicket(seat));

    this.setState(
      {
        tickets,
        hasSeats: false,
      },
      () => {
        this.setPrice();
      }
    );
  };

  callAPIs = async () => {
    try {
      this.setState({ loading: true });
      const { id, slug, transactionId } = this.props.match.params;

      switch (true) {
        case !!slug:
          await this.getEventData();
          break;
        case !!transactionId:
          this.setState({ isOffers: true });
          await this.getOfferTransactionData();
          break;
        default:
          throw Error();
      }

      if (id) {
        await this.getTransactionData();
      }

      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false });

      const txt = getCurrentLanguageTexts();

      showErrorModal({
        title: e.errorMessage ? txt.generalTxt["error"] : txt.generalTxt["Something Went Wrong"],
        text: e.errorMessage || txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal modal-with-custom-theme",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      });
      console.log(e);
    }
  };

  setChart = (c) => {
    this.setState({ chart: c })
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.state.step === 1) {
      if (
        this.state.chart
        && oldState.chart
        && this.state.chart.state !== oldState.chart.state
        && oldState.tickets
      ) {
        const labels = this.state.tickets.map(t => t.label)
        this.state.chart.trySelectObjects(labels);
      }
    }

    if (oldState.coupon !== this.state.coupon) {
      this.setPrice();
    }

    if (this.formRef.current && this.state.theme) {
      this.formRef.current.style.setProperty("--primary-color", this.state.theme.primaryColor);
      this.formRef.current.style.setProperty("--primary-semi-light-color", this.state.theme.primarySemiLightColor)
      this.formRef.current.style.setProperty("--primary-light-color", this.state.theme.primaryLightColor)
      this.formRef.current.style.setProperty("--primary-text-color", this.state.theme.primaryTextColor)
      this.formRef.current.style.setProperty("--reject-button-color", this.state.theme.rejectButtonColor)
      this.formRef.current.style.setProperty("--secondary-color", this.state.theme.secondaryColor)
      this.formRef.current.style.setProperty("--secondary-light-color", this.state.theme.secondaryLightColor)
      this.formRef.current.style.setProperty("--secondary-text-color", this.state.theme.secondaryTextColor)
    }
  }

  componentDidMount() {
    this.callAPIs();

    if (window.location.origin.includes('sixtix.rs')) {
      setLangCode('rs');
    } else {
      setLangCode('en');
    }

    const { transactionId } = this.props.match.params;

    if (!!transactionId) {
      window.addEventListener('beforeunload', (event) => {
        MySwal.close();
      });
    };

    this.setState({ isPageLoaded: true, });
  }

  handleMouseEnter = () => {
    this.setState({ isBtnHover: true });
  };
  handleMouseLeave = () => {
    this.setState({ isBtnHover: false });
  };

  render() {
    const {
      step,
      fields,
      coupon,
      checkboxeFields,
      tickets,
      ticketTemplate,
      transactionData,
      eventData,
      loading,
      hasSeats,
      feeRate,
      fixedFeeRate,
      isOffers,
      reapetedBuyerEmail,
      theme,
      isBtnHover,
      isNextStepLoading,
    } = this.state;
    const txt = getCurrentLanguageTexts();

    const visibleBankLogos = getVisibleBankLogos(eventData);

    this.setCouponHandler = (c) => {
      this.setState({ coupon: c });
    };

    this.setCouponHandler = this.setCouponHandler.bind(this);

    if (loading && !isOffers) {
      return <NewLoader isFullScreen />;
    }

    if (!eventData) {
      return null;
    }

    const time = moment(eventData.startDate).format("DD.MM.YYYY HH:mm");

    const pricing = eventData.ticketTemplates.map(({ ticketTemplateId, categoryKey, price }) => ({
      category: categoryKey,
      ticketTemplateId: ticketTemplateId,
      price,
    }));

    const prefixLabel = eventData.prefixLabel || "";
    const region = getRegion(theme);

    const location = eventData.place || "";

    const { companyVatNumber, companyName, ...otherFields } = fields;
    const requiredFields = Object.keys(otherFields);

    const totalFee = getTotalFee(tickets, fixedFeeRate, feeRate, ticketTemplate, coupon);

    const btnStyle = {
      backgroundColor: `${theme && !this.checkActionButtonDisabled() ? theme.primaryColor : ''}`,
      boxShadow: `${theme && isBtnHover ? `0px 0px 8px 0px ${theme.primaryColor}` : ''}`,
    }

    const offerSteps = [
      {
        title: txt.sellPageTxt["Buy tickets"],
        component:
          <OfferSteps
            tickets={tickets}
            coupon={coupon}
            pricing={pricing}
            totalFee={totalFee}
            loading={loading}
            hasSeats={hasSeats}
            requiredFields={requiredFields}
            fields={fields}
            checkboxeFields={checkboxeFields}
            transactionData={transactionData}
            eventData={eventData}
            handleChange={this.handleChange}
            onObjectSelected={this.onTicketAdded}
            onObjectDeselected={this.onTicketRemoved}
            setCouponHandler={this.setCouponHandler}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
            theme={theme}
          />,
      },
    ];

    const steps = [
      {
        title: txt.sellPageTxt["Select Tickets"],
        component: (
          <SelectTickets
            totalFee={totalFee}
            tickets={tickets}
            ticketTemplates={eventData.ticketTemplates}
            maxSelectedObjects={eventData.maxSeatsToSelectPerTransaction}
            pricing={pricing}
            hasSeats={hasSeats}
            workspaceKey={eventData.seatsIoWorkspaceId}
            eventSeatsId={eventData.seatsIoEventId}
            event={eventData}
            currency={transactionData.currencyCode}
            onObjectSelected={this.onTicketAdded}
            onObjectDeselected={this.onTicketRemoved}
            total={transactionData.paymentAmount}
            setCouponHandler={this.setCouponHandler}
            coupon={coupon}
            theme={theme}
            isTermsChecked={checkboxeFields.termsAndConditionsChecked}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
            isTermsCheckbox={false}
            onSetChart={this.setChart}
            isNextStepLoading={isNextStepLoading}
          />
        ),
      },
      {
        title: txt.sellPageTxt["Fill in the info"],
        component: (
          <FillFields
            fields={fields}
            requiredFields={requiredFields}
            handleChange={this.handleChange}
            checkboxeFields={checkboxeFields}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
            theme={theme}
          />
        ),
      },
      {
        title: txt.sellPageTxt["Buy tickets"],
        component: (
          <ChoosePaymentMethod
            buyerEmail={fields.buyerEmail}
            reapetedBuyerEmail={reapetedBuyerEmail}
            handleRepaetEmailChange={this.handleRepaetEmailChange}
            totalFee={totalFee}
            hasSeats={hasSeats}
            currency={transactionData.currencyCode}
            email={fields.buyerEmail}
            tickets={tickets}
            total={transactionData.paymentAmount}
            paymentMethod={fields.paymentMethod}
            handleChange={this.handleChange}
            setCouponHandler={this.setCouponHandler}
            coupon={coupon}
            allowEnterCouponCode={false}
            theme={theme}
            paymentMethodOptions={eventData.allowedPaymentProviders.flatMap(p => {
              return p.methods.map(m => {
                return {
                  id: p.providerId,
                  value: paymentMethodOptions[p.providerId],
                  label: m.name,
                }
              })
            })}
            onObjectDeselected={this.onTicketRemoved}
          />
        ),
      },
    ];

    const headerComponent = (
      <div>
        <h2 className="partizan-open-selling__stepper-header-event-name">
          {prefixLabel}
        </h2>
        <h2 className="partizan-open-selling__stepper-header-title">
          {eventData.eventName}
        </h2>
        <h5 className="partizan-open-selling__stepper-header-subtitle">
          {txt.sellPageTxt["Supported by"]} {region.title}
        </h5>
        <div className="partizan-open-selling__stepper-header-info">
          <div className="partizan-open-selling__stepper-header-info-location">
            <Icon name={"map-pin-solid"} />
            <p>{location}</p>
          </div>
          <p className="partizan-open-selling__stepper-header-info-time">
            {time}
          </p>
        </div>
      </div>
    );

    const offerActionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div
          style={{ justifyContent: "flex-end" }}
          className="partizan-open-selling__stepper-action-btns"
        >
          <button
            className="btn-primary"
            type="button"
            disabled={this.checkActionButtonDisabled()}
            onClick={this.handleSubmit}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            style={btnStyle}
          >
            {txt.sellPageTxt["Pay"]}
          </button>
        </div>
        <div className="seasonpass__bank-logos">
          {visibleBankLogos.map(({ alt, src, link }) => (
            <div key={alt}>
              <a className="partizan-open-selling__bank-link" target="_blank" rel="noopener noreferrer" href={link}>
                <img
                  className={cn("partizan-open-selling__bank-img", { "partizan-open-selling__bank-img--visa": alt === "Visa" })}
                  src={src}
                  alt={link}
                />
              </a>
            </div>
          ))}
        </div>

        {(
          window.location.origin.includes('sixtix.rs')
          || window.location.hostname === 'localhost'
          || window.location.origin.includes('dev-')
        ) && (
            <footer className="partizan-open-selling__footer sell-footer">
              <div className="sell-footer__left-side">
                <div className="sell-footer__title">
                  {txt.sellPageTxt["Contacts"]}
                </div>

                <ul className="sell-footer__contacts-list" dangerouslySetInnerHTML={{ __html: region.footer }}></ul>
              </div>
              <div className="sell-footer__right-side">
                <a
                  href={region.policyLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{
                    color: `${theme && theme.primaryColor}`
                  }}
                >
                  {txt.sellPageTxt["Privacy Policy"]}
                </a>
                <a
                  href={region.termsLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{
                    color: `${theme && theme.primaryColor}`
                  }}
                >
                  {txt.sellPageTxt["Terms of Service"]}
                </a>
              </div>
            </footer>
          )}
      </div>
    );

    const actionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div className="partizan-open-selling__stepper-action-btns">
          {step === 1 ? <span></span> : (
            <button
              className="btn-secondary"
              type="button"
              onClick={() => this.handleChangeStep(step - 1)}
            >
              {txt.sellPageTxt["Previous"]}
            </button>
          )}
          {steps.length === step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={this.handleSubmit}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              style={btnStyle}
            >
              {txt.sellPageTxt["Pay"]}
            </button>
          )}
          {steps.length !== step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={() => this.handleChangeStep(step + 1)}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              style={btnStyle}
            >
              {txt.sellPageTxt["Next"]}
            </button>
          )}
        </div>
        <div className="seasonpass__bank-logos">
          {visibleBankLogos.map(({ alt, src, link }) => (
            <div key={alt}>
              <a className="partizan-open-selling__bank-link" target="_blank" rel="noopener noreferrer" href={link}>
                <img
                  className={cn("partizan-open-selling__bank-img", { "partizan-open-selling__bank-img--visa": alt === "Visa" })}
                  src={src}
                  alt={link}
                />
              </a>
            </div>
          ))}
        </div>
        {(
          window.location.origin.includes('sixtix.rs')
          || window.location.hostname === 'localhost'
          || window.location.origin.includes('dev-')
        ) && (
            <footer className="partizan-open-selling__footer sell-footer">
              <div className="sell-footer__left-side">
                <div className="sell-footer__title">
                  {txt.sellPageTxt["Contacts"]}
                </div>

                <ul className="sell-footer__contacts-list" dangerouslySetInnerHTML={{ __html: region.footer }}></ul>
              </div>
              <div className="sell-footer__right-side">
                <a
                  href={region.policyLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{
                    color: `${theme && theme.primaryColor}`
                  }}
                >
                  {txt.sellPageTxt["Privacy Policy"]}
                </a>
                <a
                  href={region.termsLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{
                    color: `${theme && theme.primaryColor}`
                  }}
                >
                  {txt.sellPageTxt["Terms of Service"]}
                </a>
              </div>
            </footer>
          )}
      </div>
    );

    return (
      <Container className="seasonpass partizan-open-selling">
        <form ref={this.formRef}
          className="partizan-open-selling__wrapper"
        >
          <div className="partizan-open-selling__logo seasonpass__header-logo-wrapper">
            <img src={`/${region.theme}/logo.png`} alt="Logo" />
            <h2>{region.title}</h2>
          </div>

          <Stepper
            headerStyle={{
              backgroundImage:
                `url(${window.screen.width <= 480 && eventData.mobileImageUrl
                  ? eventData.mobileImageUrl
                  : eventData.imageUrl}
                )`,
              color: `${theme ? theme.secondaryTextColor : '#fff'}`
            }}
            headerWrapperClass="partizan-open-selling__stepper-header"
            headerComponent={headerComponent}
            actionComponent={isOffers ? offerActionComponent : actionComponent}
            currentStep={step}
            steps={isOffers ? offerSteps : steps}
            theme={theme}
          />
        </form>
      </Container>
    );
  }
}

export default withRouter(OpenSell);

